module.exports = __webpack_public_path__ + "html/subscription-total-price_3a8a5f86b9e8c5d2d53f28be70045394.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/subscription/subscription-total-price.html
// module id = Mu6H
// module chunks = 52